import { type ReactElement } from 'react';
import { Alert, Box, Button } from '@ff-it/ui';
import { useToolbarSelection, selectionEnabledAtom } from '../state';
import { useAtom } from 'jotai';
import { BulkActions } from './BulkActions';

export function SelectionControls(): ReactElement | null {
  const [selected, celarSelection] = useToolbarSelection();
  const [selectionEnabled, setSelectionEnabled] = useAtom(selectionEnabledAtom);

  return (
    <Box display="flex" gap="1">
      {!selectionEnabled ? (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => setSelectionEnabled(true)}
          testId="toggle-selection"
          active={false}
          icon="square-check"
        >
          Select
        </Button>
      ) : (
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            celarSelection();
            setSelectionEnabled(false);
          }}
          testId="toggle-selection"
          active={true}
          icon="square-xmark"
          data-selected-rows={selected.length}
        >
          Clear selection
        </Button>
      )}
      {selected.length > 100 ? (
        <Alert variant="danger" className="block-notice d-inline-block" ml="1" mb="3">
          Too many ({selected.length}) rows selected
        </Alert>
      ) : selected.length ? (
        <BulkActions selected={selected} celarSelection={celarSelection} />
      ) : null}
    </Box>
  );
}
